import {
  TEMPLATE_COLUMN_IDENTIFIER_PREFIX,
  TEMPLATE_LINE_IDENTIFIER_PREFIX,
  TEMPLATE_SECTION_CONTENT_ID_SUFFIX,
  TEMPLATE_SECTION_IDENTIFIER_PREFIX,
  TEMPLATE_WIDGET_IDENTIFIER_PREFIX,
  TEMPLATE_TRANSLATE_SPECIFIC,
  TEMPLATE_TRANSLATE_SPECIFIC_ITEMS,
  TEMPLATE_TRANSLATE_SPECIFIC_ONLY_ATTRIBUTE,
  TEMPLATE_TRANSLATE_SPECIFIC_ONLY_CONTENT,
  WIDGETS_PLACEHOLDER_IDENTIFIER,
  WIDGET_IMPORT_ZIP_PLACEHOLDER_IDENTIFIER,
} from '@/components/template-builder/utils/constants';
import { registerWidgetCss } from '@/components/template-builder/utils/widget-css-manager';
// eslint-disable-next-line import/no-cycle
import { generateUniqStructureId } from '@/components/template-builder/utils/helpers';
import { WidgetTypeEnum } from '@/types';
import { faArrowToBottom, faTrashAltRegular } from '@/components/template-builder/utils/icons-definition';
// eslint-disable-next-line import/no-cycle
import { getSocialNetworksLinks } from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import { UserState } from '@/composables/User';

// structures
export const rawWidgetPlaceholder = () => `<div class="${WIDGETS_PLACEHOLDER_IDENTIFIER}">${faTrashAltRegular}${faArrowToBottom}</div>`;

export const rawColumn = () => {
  const columnId = `${TEMPLATE_COLUMN_IDENTIFIER_PREFIX}_${generateUniqStructureId()}`;
  return `<th id="${columnId}" class="column spm_droppable_widget spm_droppable" style="width: 100%;">${rawWidgetPlaceholder()}</th>`;
};

export const rawLine = () => {
  const lineId = `${TEMPLATE_LINE_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table id="${lineId}"
    class="spm_draggable_row ui-droppable" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td>
    <table class="row spm_responsive" cellspacing="0" cellpadding="0"><tbody><tr><td><table class="columns" cellspacing="0" cellpadding="0"><tbody><tr>${rawColumn()}
    </tr></tbody></table></td></tr></tbody></table></td></tr></tbody>`;
};

export const rawSection = () => {
  const sectionId = `${TEMPLATE_SECTION_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table style="width: 100%;
    border-collapse: collapse;" class="spm_section spm_responsive" id="${sectionId}" cellspacing="0" cellpadding="0"><tbody><tr><td class="center" align="center">
    <center><table class="container" id="${sectionId}${TEMPLATE_SECTION_CONTENT_ID_SUFFIX}" cellspacing="0" cellpadding="0"><tbody><tr><td class="spm_droppable_row">
    ${rawLine()}</td></tr></tbody></table></center></td></tr></tbody></table>`;
};

export const rawMandatoryVariablesWidget = (t: any, hasUnsubscribeUrlLink: boolean) => {
  const lineId = `${TEMPLATE_LINE_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const columnId = `${TEMPLATE_COLUMN_IDENTIFIER_PREFIX}_${generateUniqStructureId()}`;
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const texts = [];

  if (!hasUnsubscribeUrlLink) {
    texts.push(t('templateBuilder.unsubscribeLinkWidget').replace('%s', '{var=template.unsubscribe_url}'));
  }

  return `<table id="${lineId}" class="spm_draggable_row" width="100%" cellspacing="0" cellpadding="0">
  <tbody>
    <tr>
      <td>
        <table class="row spm_responsive" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <td>
                <table class="columns" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <th id="${columnId}" class="column spm_droppable_widget spm_droppable" style="width: 100%;">
                        <table data-widgettype="spm_widget_text" class="spm_widget_text spm_draggable_widget" id="${widgetId}"
                            style="border-collapse: collapse; display: table;" width="100%" cellspacing="0" cellpadding="0">
                          <tbody>
                            <tr>
                              <th>
                                <table class="spm_rich_editor_wrapper" cellspacing="0" cellpadding="0" width="100%">
                                  <tbody>
                                    <tr>
                                      <td>
                                        <div class="spm_rich_editor">${texts.join('<br />')}</div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</table>`;
};

// widgets
const rawWidgetSpacer = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_widget_spacer spm_draggable_widget" data-widgettype="spm_widget_spacer" style="border-collapse: collapse;"><tbody><tr>
    <th style="height: 20px;">&nbsp;</th></tr></tbody></table>`;
};

const rawWidgetSeparator = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_widget_separator spm_draggable_widget" data-widgettype="spm_separator" style="border-collapse: collapse;"><tbody><tr>
    <th><table border="0" width="100%" cellpadding="0" cellspacing="0" class="spm_separator" align="center" style="border-collapse: collapse;">
    <tbody><tr><th>&nbsp;</th></tr></tbody></table></th></tr></tbody></table>`;
};

const rawWidgetText = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const text = `<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultricies lectus egestas nulla mollis cursus.
  Sed nec lectus non nulla auctor aliquam. <br /><br /> Mauris facilisis at lectus nec consequat.
  Donec at condimentum turpis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>`;
  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_widget_text spm_draggable_widget" data-widgettype="spm_widget_text" style="border-collapse: collapse;"><tbody><tr>
    <th><table class="spm_rich_editor_wrapper" cellspacing="0" cellpadding="0" width="100%" style="border-collapse: collapse;"><tbody><tr><td><div class="spm_rich_editor">${text}</div></td></tr></tbody></table></th></tr></tbody></table>`;
};
const rawWidgetTitle = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_widget_title spm_draggable_widget" data-widgettype="spm_widget_title" style="border-collapse: collapse;">
    <tbody>
      <tr>
        <th>
          <table class="spm_title_wrapper" cellspacing="0" cellpadding="0">
            <tr>
              <th>
                <h1>Votre titre ici</h1>
              </th>
            </tr>
          </table>
        </th>
      </tr>
    </tbody>
  </table>`;
};

const rawWidgetImage = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const src = 'http://media.shopimind.io/img/v4/placeholders/image_placeholder.png';
  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_widget_image spm_draggable_widget" data-widgettype="spm_widget_image" style="border-collapse: collapse;"><tbody><tr>
    <th><a href="{var=shop.url}">
      <img src="${src}" width="100%" alt="">
    </a></th></tr></tbody></table>`;
};

const rawWidgetSocialMedia = (additionalConfiguration: Record<string, any>) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  let socialNetworksHtml = '';

  if (!additionalConfiguration.socialNetworks || !Array.isArray(additionalConfiguration.socialNetworks)) {
    // eslint-disable-next-line no-param-reassign
    additionalConfiguration.socialNetworks = [];
  }

  if ('socialNetworks' in additionalConfiguration && additionalConfiguration.socialNetworks && Array.isArray(additionalConfiguration.socialNetworks)) {
    if (additionalConfiguration.socialNetworks.length === 0) {
      additionalConfiguration.socialNetworks.push('facebook');
      additionalConfiguration.socialNetworks.push('twitter');
      additionalConfiguration.socialNetworks.push('email');
    }

    additionalConfiguration.socialNetworks.forEach((network: string) => {
      const variable = network === 'email' ? 'contact' : network;
      socialNetworksHtml += `<td class="spm_${network} spm_social_icon_container spm_social_icon">
        <a class="${TEMPLATE_TRANSLATE_SPECIFIC_ONLY_ATTRIBUTE}" href="{var=social.${variable}_url}">
          <img src="https://media.shopimind.io/img/icons/socialv2/2/${network}.png" alt="${network}" width="32" style="max-width:32px;width:32px;" />
        </a>
      </td>`;
    });
  }

  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_widget_follow spm_draggable_widget" data-widgettype="spm_widget_follow">
    <tbody><tr><th><table class="spm_social_icons spm_social_icons_horizontal" align="center" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>${socialNetworksHtml}</tr>
      </tbody>
    </table>
  </th></tr></tbody></table>`;
};

const rawWidgetShareSocialMedia = (additionalConfiguration: Record<string, any>) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const shareLinks = getSocialNetworksLinks('{var=template.private_archive_url}');
  let socialNetworksHtml = '';
  if (!additionalConfiguration.socialNetworks || !Array.isArray(additionalConfiguration.socialNetworks)) {
    // eslint-disable-next-line no-param-reassign
    additionalConfiguration.socialNetworks = [];
  }
  if ('socialNetworks' in additionalConfiguration && additionalConfiguration.socialNetworks && Array.isArray(additionalConfiguration.socialNetworks)) {
    if (additionalConfiguration.socialNetworks.length === 0) {
      additionalConfiguration.socialNetworks.push('facebook');
      additionalConfiguration.socialNetworks.push('twitter');
      additionalConfiguration.socialNetworks.push('email');
    }
    additionalConfiguration.socialNetworks.forEach((network: string) => {
      socialNetworksHtml += `<td class="spm_${network} spm_social_icon_container spm_social_icon">
        <a href="${shareLinks[network]}">
          <img src="https://media.shopimind.io/img/icons/socialv2/2/${network}.png" alt="${network}" width="32" style="max-width:32px;width:32px;" />
        </a>
      </td>`;
    });
  }

  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_widget_share spm_draggable_widget" data-widgettype="spm_widget_share" style="border-collapse: collapse;"><tbody><tr>
    <th><table class="spm_social_icons spm_social_icons_horizontal" align="center" cellspacing="0" cellpadding="0">
      <tr>${socialNetworksHtml}</tr>
    </table></th></tr></tbody></table>`;
};

const rawWidgetCode = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_widget_code spm_draggable_widget" data-widgettype="spm_widget_code" style="border-collapse: collapse;"><tbody><tr>
    <th><p>Insert your own HTML code</p></th></tr></tbody></table>`;
};

const rawWidgetButton = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_call_to_action spm_draggable_widget" data-widgettype="spm_call_to_action" style="border-collapse: collapse;"><tbody><tr>
    <th><table class="spm_button" width="100%" cellspacing="0" cellpadding="0"><tr><th valign="middle">
      <a href="{var=shop.url}">Votre texte ici</a>
    </th></tr></table></th></tr></tbody></table>`;
};

const rawWidgetGdprButton = (t: Function) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_call_to_action_rgpd spm_draggable_widget" data-widgettype="spm_call_to_action_rgpd" style="border-collapse: collapse;"><tbody><tr>
    <th><table class="spm_button" cellspacing="0" cellpadding="0"><tr><th valign="middle">
      <a href="{var=link_double_optin}" class="spm_inline_editing">${t('templateBuilder.gdprDefaultLabel')}</a>
    </th></tr></table></th></tr></tbody></table>`;
};

const rawWidgetSmartProductList = (t: Function) => () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table id="${widgetId}" class="spm_draggable_widget spm_smart_products_list" data-widgettype="spm_smart_products_list" width="100%"
    cellspacing="0" cellpadding="0">
    <tbody>
      <tr>
        <th>
          <table class="row spm_title_wrapper spm_product_list_title_wrapper spm_responsive">
            <tbody>
              <tr>
                <th><h1 class="spm_product_list_title spm_inline_editing">${t('templateBuilder.smartProductListDefaultTitle')}</h1></th>
              </tr>
            </tbody>
          </table>
          <table class="row spm_product_list spm_product_list_horizontal_3">
            <tr>
              <td>
                <table class="columns spm_product_list_element_container">
                  <tr class="spm_product_list_element_row">
                      <th class="column spm_product_list_element" style="width: 33.33333%;"
                      s-collection="products" s-item="product" s-grid="3" s-nb="3" s-engine="crossselling"
                      s-ids="" s-excluded_ids="" s-excluded_categories="" s-excluded_manufacturers="" s-nb_weeks="4">
                      <h4 class="spm_product_list_element_title"><a href="{var=product.url}" title="{var=product.name}">{var=product.name truncate="40"}</a></h4>
                        <p class="spm_product_list_element_image_wrapper" style="text-align:center;margin:0;padding:0;">
                          <a href="{var=product.url}">
                            <img src="{var=product.image_url resize=400x400 resizeType=fill-to-fit}"
                            width="150" class="spm_product_list_element_image" alt="{var=product.name}" title="{var=product.name}" />
                          </a>
                        </p>
                        <table class="spm_product_list_element_description spm_hide_on_builder" style="height:70px;"
                        height="70" cellpadding="0" cellspacing="0" border="0" width="100%">
                            <tr>
                              <td><p>{var=product.description_short truncate="80"}</p></td>
                            </tr>
                        </table>
                        <table class="row">
                            <tr>
                              <td>
                                <table class="columns spm_product_list_element_prices">
                                  <tr>
                                    <th s-if="product.price_strike" s-condition="!=" s-value="product.price" class="column" align="center" valign="middle">
                                      <p class="spm_product_list_element_price_strike">{var=product.price_strike}</p>
                                    </th>
                                    <th class="column" align="center" valign="middle">
                                      <p class="spm_product_list_element_price">{var=product.price}</p>
                                    </th>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                        </table>
                        <table class="spm_button spm_product_list_element_button spm_display_fullwidth_mobile" width="100%" cellspacing="0" cellpadding="0">
                          <tr>
                            <th><a href="{var=product.url}"  title="${t('templateBuilder.smartProductListDefaultButton')}">${t('templateBuilder.smartProductListDefaultButton')}</a></th>
                          </tr>
                        </table>
                      </th>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </th>
      </tr>
    </tbody>
  </table>`;
};

const rawWidgetImportZip = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table cellspacing="0" cellpadding="0" width="100%"
            id="${widgetId}"
            class="spm_widget_import_zip spm_draggable_widget ${TEMPLATE_TRANSLATE_SPECIFIC}"
            data-widgettype="spm_widget_import_zip"
            style="border-collapse: collapse;"
            data-widgetid="${widgetId}"><tbody><tr>
    <th>${WIDGET_IMPORT_ZIP_PLACEHOLDER_IDENTIFIER}</th></tr></tbody></table>`;
};

const rawWidgetCountdown = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  // Default end date: 7 days from now
  const defaultEndDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString();
  // Use shop timezone or default to Europe/Paris
  const shopTimezone = UserState.activeShop?.timezone || 'Europe/Paris';

  // Build default GIF URL
  const defaultParams = new URLSearchParams({
    endDate: defaultEndDate,
    timezone: shopTimezone,
    showDays: 'true',
    showHours: 'true',
    showMinutes: 'true',
    showSeconds: 'true',
    labelDays: 'JOURS',
    labelHours: 'HEURES',
    labelMinutes: 'MIN',
    labelSeconds: 'SEC',
    digitBgColor: '1a1a1a',
    digitColor: 'ffffff',
    digitSize: '48',
    digitFontWeight: '700',
    digitBorderRadius: '8',
    digitPadding: '15',
    labelColor: '000000',
    labelSize: '13',
    labelFontWeight: '400',
    separatorType: 'colon',
    separatorColor: '000000',
    layout: 'horizontal',
    gap: '10',
    width: '500',
    height: '100',
    bgColor: 'ffffff',
  });

  const gifUrl = `${process.env.VUE_APP_NESTJS_TRACKING_API_URL}/countdown/gif?${defaultParams.toString()}`;

  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}"
    class="spm_widget_countdown spm_draggable_widget"
    data-widgettype="spm_widget_countdown"
    data-end-date="${defaultEndDate}"
    data-timezone="${shopTimezone}"
    data-show-days="true"
    data-show-hours="true"
    data-show-minutes="true"
    data-show-seconds="true"
    data-label-days="JOURS"
    data-label-hours="HEURES"
    data-label-minutes="MIN"
    data-label-seconds="SEC"
    data-digit-bg-color="#1a1a1a"
    data-digit-color="#ffffff"
    data-digit-size="48"
    data-digit-font-weight="700"
    data-digit-border-radius="8"
    data-digit-padding="15"
    data-label-color="#000000"
    data-label-size="13"
    data-label-font-weight="400"
    data-separator-type="colon"
    data-separator-color="#000000"
    data-layout="horizontal"
    data-gap="10"
    data-width="500"
    data-height="100"
    data-bg-color="#ffffff"
    style="border-collapse: collapse;">
    <tbody>
      <tr>
        <th style="text-align: center;">
          <img
            class="spm_countdown_gif spm_no_translate"
            src="${gifUrl}"
            alt="Countdown Timer"
            width="500"
            height="100"
            style="max-width: 100%; height: auto; display: inline-block;"
          />
        </th>
      </tr>
    </tbody>
  </table>`;
};

const rawWidgetMenu = () => {
  const widgetId = `${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  const menuItems = ['Menu 1', 'Menu 2', 'Menu 3', 'Menu 4'];
  const menuHtml = menuItems.map((label) => `<td class="spm_menu_item"><table cellspacing="0" cellpadding="0"><tbody><tr><th><a href="{var=shop.url}">${label}</a></th></tr></tbody></table></td>`).join('');
  return `<table cellspacing="0" cellpadding="0" width="100%"
    id="${widgetId}" class="spm_widget_menu spm_draggable_widget" data-widgettype="spm_widget_menu" style="border-collapse: collapse;"><tbody><tr>
    <th><table class="spm_menu spm_menu_horizontal spm_responsive_menu" align="center" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>${menuHtml}</tr>
      </tbody>
    </table>
  </th></tr></tbody></table>`;
};

export const rawColumnsLayout = (percentages: number[]) => {
  let html = '';

  percentages.forEach((percentage) => {
    const columnId = `${TEMPLATE_COLUMN_IDENTIFIER_PREFIX}_${generateUniqStructureId()}`;
    html += `<th id="${columnId}" class="column spm_droppable_widget spm_droppable" style="width: ${percentage}%;">${rawWidgetPlaceholder()}</th>`;
  });

  return html;
};

export const rawLineWithColumns = (percentages: number[]) => {
  const lineId = `${TEMPLATE_LINE_IDENTIFIER_PREFIX}${generateUniqStructureId()}`;
  return `<table id="${lineId}"
    class="spm_draggable_row ui-droppable" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td>
    <table class="row spm_responsive" cellspacing="0" cellpadding="0"><tbody><tr><td>
    <table class="columns" cellspacing="0" cellpadding="0"><tbody><tr>${rawColumnsLayout(percentages)}
    </tr></tbody></table></td></tr></tbody></table></td></tr></tbody>`;
};

export const rawWidgets = (t: Function, additionalConfiguration: Record<string, any>): { [key: string]: () => string } => ({
  [WidgetTypeEnum.SPACER]: rawWidgetSpacer,
  [WidgetTypeEnum.SEPARATOR]: rawWidgetSeparator,
  [WidgetTypeEnum.TEXT]: rawWidgetText,
  [WidgetTypeEnum.TITLE]: rawWidgetTitle,
  [WidgetTypeEnum.IMAGE]: rawWidgetImage,
  [WidgetTypeEnum.SOCIAL_MEDIA]: rawWidgetSocialMedia(additionalConfiguration),
  // [WidgetTypeEnum.SHARE_SOCIAL_MEDIA]: rawWidgetShareSocialMedia(additionalConfiguration), // Désactivé - widget non maintenu
  [WidgetTypeEnum.CODE]: rawWidgetCode,
  [WidgetTypeEnum.BUTTON]: rawWidgetButton,
  [WidgetTypeEnum.GDPR_BUTTON]: rawWidgetGdprButton(t),
  [WidgetTypeEnum.SMART_PRODUCT_LIST]: rawWidgetSmartProductList(t),
  [WidgetTypeEnum.IMPORT_ZIP]: () => rawWidgetImportZip(),
  [WidgetTypeEnum.COUNTDOWN]: rawWidgetCountdown,
  [WidgetTypeEnum.MENU]: rawWidgetMenu,
  [WidgetTypeEnum.COLUMN]: () => '', // Empty string. Only used to display the widget in the panel. Code of widget is returned by getColumnsWidgetLayouts
  [WidgetTypeEnum.SECTION]: () => '', // Empty string. Only used to display the widget in the panel. Code of widget is returned by getColumnsWidgetLayouts
});

// ---- Widget CSS Registration (auto-injected on widget drop, auto-removed when last instance deleted) ----
registerWidgetCss('spm_widget_menu', {
  static: [
    {
      selector: '#spm_body .spm_widget_menu > tbody > tr > th > table .spm_menu_item',
      properties: 'padding:5px;',
    },
    {
      selector: '#spm_body .spm_widget_menu > tbody > tr > th > table .spm_menu_item > table > tbody > tr > th',
      properties: 'padding:10px;font-weight: inherit;line-height:100%!important;',
    },
    {
      selector: '#spm_body .spm_widget_menu > tbody > tr > th > table .spm_menu_item a',
      properties: 'display: block;height: 100%;text-decoration: none;line-height:100%!important;',
    },
    {
      selector: '#spm_body .spm_widget_menu table.spm_menu_vertical, #spm_body .spm_widget_menu table.spm_menu_vertical table',
      properties: 'width:100%;',
    },
  ],
  static_persistent_mobile: [
    {
      selector: '#spm_body .spm_responsive .spm_widget_menu .spm_responsive_menu > tbody, #spm_body .spm_responsive .spm_widget_menu .spm_responsive_menu > tbody > tr, #spm_body .spm_responsive .spm_widget_menu .spm_responsive_menu > tbody > tr > td, #spm_body .spm_responsive .spm_widget_menu .spm_responsive_menu > tbody > tr > th',
      properties: 'display: block !important;',
    },
  ],
});
